import { HelmetDexteel } from "@dexteel/mesf-core";
import { TestsBySectionTable } from "./components/TestsBySectionTable";

export const TestsBySectionPage = () => {
	return (
		<>
			<HelmetDexteel title="Tests by Section" />
			<TestsBySectionTable />
		</>
	);
};
